module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.path == "/agentColoader/agentColoaderForm" && _vm.Type ?
    _vm.Type :
    "Agent & Co-Loader"))]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [(
    _vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
  ) ? _c('b-nav-form', [(_vm.showMain == false) ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.goToMain
    }
  }, [_vm._v("Add New")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReportsAss('All_AgentColoder_Report', 'Export as Excel')
      }
    }
  }, [_vm._v("\n              " + _vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.ShowImportModal
    }
  }, [_vm._v("Import Excel")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.showMain == true) ? _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent / CoLoader")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "placeholder": "Select Type"
    },
    model: {
      value: (_vm.agentColaderModel.categoryType),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "categoryType", $$v)
      },
      expression: "agentColaderModel.categoryType"
    }
  }), _vm._v(" "), (!_vm.agentColaderModel.categoryType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.categoryTypeError))]) : _vm._e()], 1), _vm._v(" "), (_vm.agentColaderModel.categoryType == 'Agent') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Engagement Preference")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.engagementPreferenceList,
      "option-value": "engagementTypeVal",
      "option-text": "engagementTypeTxt",
      "placeholder": "Select Engagement Preference"
    },
    model: {
      value: (_vm.agentColaderModel.engagementPreference),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "engagementPreference", $$v)
      },
      expression: "agentColaderModel.engagementPreference"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.agentColaderModel.categoryType != 'CoLoader') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Agent Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "agentName",
      "name": "agentName"
    },
    model: {
      value: (_vm.agentColaderModel.agentName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "agentName", $$v)
      },
      expression: "agentColaderModel.agentName"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.agentColaderModel.categoryType == 'CoLoader') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("CoLoader Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "coLoaderName",
      "name": "coLoaderName"
    },
    model: {
      value: (_vm.agentColaderModel.coLoaderName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "coLoaderName", $$v)
      },
      expression: "agentColaderModel.coLoaderName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Contact No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "contactNumber",
      "name": "contactNumber"
    },
    model: {
      value: (_vm.agentColaderModel.contactNumber),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "contactNumber", $$v)
      },
      expression: "agentColaderModel.contactNumber"
    }
  })], 1), _vm._v(" "), (_vm.agentColaderModel.categoryType != 'Agent') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Email-Id")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId"
    },
    model: {
      value: (_vm.agentColaderModel.emailId),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "emailId", $$v)
      },
      expression: "agentColaderModel.emailId"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('b-row', [(_vm.agentColaderModel.categoryType == 'Agent') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Email-Id")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "emailId",
      "name": "emailId"
    },
    model: {
      value: (_vm.agentColaderModel.emailId),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "emailId", $$v)
      },
      expression: "agentColaderModel.emailId"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Company Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "companyName",
      "name": "companyName"
    },
    model: {
      value: (_vm.agentColaderModel.companyName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "companyName", $$v)
      },
      expression: "agentColaderModel.companyName"
    }
  })], 1), _vm._v(" "), (_vm.agentColaderModel.categoryType == 'Agent') ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Country Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "countryName",
      "name": "countryName"
    },
    model: {
      value: (_vm.agentColaderModel.countryName),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "countryName", $$v)
      },
      expression: "agentColaderModel.countryName"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "address",
      "name": "address"
    },
    model: {
      value: (_vm.agentColaderModel.address),
      callback: function($$v) {
        _vm.$set(_vm.agentColaderModel, "address", $$v)
      },
      expression: "agentColaderModel.address"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-button mt-3 justify-content-center",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addAgentColoader
    }
  }, [_vm._v(_vm._s(_vm.agentColaderModel.agntColoaderId != "" ? "Edit" : "Add"))]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1) : _vm._e(), _vm._v(" "), _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": _vm.SOAAccess == 'Yes' ||
        _vm.$route.path == '/agentColoader/agentColoaderForm' ||
        _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
        _vm.$sessionsStorage.get('cust_username') == 'admin' ?
        8 :
        12
    }
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type to Search"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.ClearFilter
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), (
    _vm.SOAAccess == 'Yes' ||
    _vm.$route.path == '/agentColoader/agentColoaderForm' ||
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'admin'
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.categoryTypeList,
      "option-value": "categoryTypeVal",
      "option-text": "categoryTypeTxt",
      "placeholder": "Select Type"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.Type),
      callback: function($$v) {
        _vm.Type = $$v
      },
      expression: "Type"
    }
  })], 1) : _vm._e(), _vm._v(" "), (
    _vm.SOAAccess == 'Yes' ||
    _vm.$route.path == '/agentColoader/agentColoaderForm' ||
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'admin'
  ) ? _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.StatusTypeList,
      "option-value": "StatusTypeVal",
      "option-text": "StatusTypeTxt",
      "placeholder": "Select Status"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.Status),
      callback: function($$v) {
        _vm.Status = $$v
      },
      expression: "Status"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (
    _vm.SOAAccess == 'Yes' ||
    _vm.$route.path == '/agentColoader/agentColoaderForm' ||
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ||
    _vm.$sessionsStorage.get('cust_username') == 'admin'
  ) ? _c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    staticClass: "mb-1",
    attrs: {
      "cols": "6"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCheckAll),
      expression: "isCheckAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isCheckAll) ? _vm._i(_vm.isCheckAll, null) > -1 : (_vm.isCheckAll)
    },
    on: {
      "click": function($event) {
        _vm.SelectAll(_vm.allAgentColoaderData)
      },
      "change": function($event) {
        var $$a = _vm.isCheckAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isCheckAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isCheckAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isCheckAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Select / Deselect All Count(" + _vm._s(this.AllAgentds.length) + ")")]), _vm._v(" "), (_vm.AllAgentds.length > 0) ? _c('Send-Email', {
    attrs: {
      "AgentId": _vm.AllAgentds,
      "AllEmailId": _vm.AllEmailId,
      "type": _vm.Type ? _vm.Type : 'Agent'
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-1 pull-right",
    attrs: {
      "cols": "6"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.allAgentColoaderData,
      "fields": _vm.fields,
      "current-page": _vm.currentPage,
      "per-page": _vm.perPage,
      "filter": _vm.filter,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      },
      "filtered": _vm.onFiltered
    },
    scopedSlots: _vm._u([{
      key: "agntColoader",
      fn: function(row0) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.AllAgentds),
            expression: "AllAgentds"
          }],
          attrs: {
            "type": "checkbox",
            "id": row0.item.emailId
          },
          domProps: {
            "value": row0.item.agntColoaderId,
            "checked": Array.isArray(_vm.AllAgentds) ? _vm._i(_vm.AllAgentds, row0.item.agntColoaderId) > -1 : (_vm.AllAgentds)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.AllAgentds,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = row0.item.agntColoaderId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.AllAgentds = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.AllAgentds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.AllAgentds = $$c
              }
            }, function($event) {
              _vm.updateSelectAll($event, row0.item)
            }]
          }
        }), _vm._v(" "), _c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "categoryType",
      fn: function(row1) {
        return [_c('span', {
          staticClass: "showMoreData",
          on: {
            "click": function($event) {
              _vm.$sessionsStorage.get('designation') == 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh' ?
                _vm.viewEdit(row1.item) :
                ''
            }
          }
        }, [_vm._v(_vm._s(row1.item.categoryType))]), _c('br'), _vm._v(" "), (row1.item.categoryType == 'Agent') ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "id": "show-btn",
            "size": "xs",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.goAgentPass(row1.item)
            }
          }
        }, [_vm._v("Update Agent Pass")]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.categoryType == 'Agent') ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "id": "show-btn",
            "size": "xs",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.showModal(row1.item)
            }
          }
        }, [_vm._v("Add Agent Factory")]) : _vm._e(), _c('br'), _vm._v(" "), (row1.item.categoryType == 'Agent') ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "id": "show-btn",
            "size": "xs",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.getAllFactory(row1.item)
            }
          }
        }, [_vm._v("View Agent Factory")]) : _vm._e()]
      }
    }, {
      key: "agentName",
      fn: function(row11) {
        return [_c('span', [_vm._v(_vm._s(row11.item.agentName != "" ? row11.item.agentName : "--"))])]
      }
    }, {
      key: "coLoaderName",
      fn: function(row12) {
        return [_c('span', [_vm._v(_vm._s(row12.item.coLoaderName != "" ? row12.item.coLoaderName : "--"))])]
      }
    }, {
      key: "contactNumber",
      fn: function(row13) {
        return [_c('span', [_vm._v("\n                    Contact No. : " + _vm._s(row13.item.contactNumber) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Email : " + _vm._s(row13.item.emailId) + "\n                    "), _c('br')])]
      }
    }, {
      key: "agntColoaderId",
      fn: function(row22) {
        return [_c('span', [_vm._v("Preference :\n                    "), _c('b', {
          staticStyle: {
            "text-transform": "capitalize"
          }
        }, [_vm._v(_vm._s(row22.item.engagementPreference))])]), _vm._v(" "), (_vm.adminToggle == 'Admin') ? _c('div', {
          attrs: {
            "id": 'row' + row22.item.agntColoaderId
          }
        }, [_c('md-switch', {
          staticClass: "md-primary",
          attrs: {
            "id": 'approval' + row22.item.agntColoaderId,
            "name": "approval",
            "value": row22.item.isACActive == 1 ? true : false
          },
          on: {
            "change": function($event) {
              _vm.activateAgent(row22.item)
            }
          }
        }, [_c('h6', [_c('br'), _vm._v(" "), _c('b-badge', {
          staticStyle: {
            "margin-left": "-45px"
          }
        }, [_vm._v(_vm._s(row22.item.isACActive == 1 ? "Active" : "In-Active"))])], 1)])], 1) : _c('div', {
          attrs: {
            "id": 'row' + row22.item.agntColoaderId
          }
        }, [_c('h6', [_c('b-badge', [_vm._v(_vm._s(row22.item.isACActive == 1 ? "Active" : "In-Active"))])], 1)])]
      }
    }, {
      key: "companyName",
      fn: function(row14) {
        return [_c('span', [_vm._v("\n                    Company Name : " + _vm._s(row14.item.companyName) + "\n                    "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("\n                    Address : " + _vm._s(row14.item.address) + "\n                    "), _c('br')])]
      }
    }, {
      key: "countryName",
      fn: function(row45) {
        return [_c('span', [_vm._v(_vm._s(row45.item.countryName)), _c('br')])]
      }
    }])
  })], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    staticClass: "my-0 pull-right",
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Import-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "id": "modal-multi-2",
      "size": "lg",
      "title": "Import Excel File"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload File")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "name": "excelUpload",
      "id": "excelUpload",
      "accept": ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
    },
    on: {
      "selected": function($event) {
        _vm.onFileChange()
      }
    },
    model: {
      value: (_vm.excelUpload),
      callback: function($$v) {
        _vm.excelUpload = $$v
      },
      expression: "excelUpload"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "Agent-Factory-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Agent Factory List'
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [(_vm.getAgentFactory.length > 0) ? _c('div', {
    staticClass: "gutr"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "factoryDetails"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Factory Title")]), _vm._v(" "), _c('th', [_vm._v("Factory Address")]), _vm._v(" "), _c('th', [_vm._v("Factory GSTIN")]), _vm._v(" "), _c('th', [_vm._v("Latitude")]), _vm._v(" "), _c('th', [_vm._v("Longitude")]), _vm._v(" "), _c('th', [_vm._v("Delete")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getAgentFactory), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), (item.enableEdit == '1') ? _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.EditFactory(item)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(item.factoryTitle) + "\n                ")]) : _c('td', [_vm._v(_vm._s(item.factoryTitle))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.factoryAddress1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.GSTIN1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.latitude))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.longitude))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.deleteData(item.multiFactoryId)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)])
  }))])]) : _vm._e()]), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-button', {
    staticClass: "mt-3",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "outline-danger",
      "size": "xs"
    },
    on: {
      "click": _vm.hideViewAgentFactoryModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "my-modal",
    attrs: {
      "hide-footer": "",
      "title": _vm.agentDetails.agentName
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h5', [_vm._v("Agent Factory Details !")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Factory Title-Location]( e.g : Pridel Pvt Ltd-Delhi)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "factoryTitle",
      "id": "factoryTitle"
    },
    model: {
      value: (_vm.factoryModal.factoryTitle),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryTitle", $$v)
      },
      expression: "factoryModal.factoryTitle"
    }
  }), _vm._v(" "), (!_vm.factoryModal.factoryTitle) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.factoryTitle))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": function (value) { return value.toUpperCase(); },
      "name": "factoryAddress1",
      "id": "factoryAddress1"
    },
    model: {
      value: (_vm.factoryModal.factoryAddress1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "factoryAddress1", $$v)
      },
      expression: "factoryModal.factoryAddress1"
    }
  }), _vm._v(" "), (!_vm.factoryModal.factoryAddress1) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.factoryAddress1))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }, [_c('b-button', {
    staticClass: "pull-left ml-4",
    attrs: {
      "disabled": _vm.factoryModal.factoryAddress1 == '' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.fetchLatLog
    }
  }, [_vm._v("Get Lat/Long")])], 1)]), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Latitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.latitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "latitude", $$v)
      },
      expression: "factoryModal.latitude"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Longitude")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "latitude",
      "name": "latitude"
    },
    model: {
      value: (_vm.factoryModal.longitude),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "longitude", $$v)
      },
      expression: "factoryModal.longitude"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GSTIN No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "name": "GSTIN1",
      "id": "GSTIN1"
    },
    model: {
      value: (_vm.factoryModal.GSTIN1),
      callback: function($$v) {
        _vm.$set(_vm.factoryModal, "GSTIN1", $$v)
      },
      expression: "factoryModal.GSTIN1"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "block": "",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.addFactory('', 'AddFactory')
      }
    }
  }, [_vm._v(_vm._s(_vm.factoryModal.multiFactoryId == "" ? "Add " : "Update ") + "\n\n      Factory\n    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close\n    ")])], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    staticClass: "addpop-zindex",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPopDeleteF",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onCloseDelete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8c72878","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/agentColoader/agentColoaderForm.vue
// module id = 2916
// module chunks = 0